"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CachedUtf8Decoder_1 = require("./CachedUtf8Decoder");
exports.default = new CachedUtf8Decoder_1.CachedUtf8Decoder();
